import { m, LazyMotion, domAnimation } from "framer-motion";
export default function AnimationContainer(props) {
  return <LazyMotion features={domAnimation} data-sentry-element="LazyMotion" data-sentry-component="AnimationContainer" data-sentry-source-file="AnimationContainer.tsx">
      <m.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} data-sentry-element="unknown" data-sentry-source-file="AnimationContainer.tsx">
        {props.children}
      </m.div>
    </LazyMotion>;
}